import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import styles from './Tabs.module.scss'

export const Tabs = ({ tabs, className }: any) => {
  const location = useLocation()

  return (
    <div className={clsx(styles['container'], className)}>
      <div className={clsx(styles['wrapper'], className)}>
        {tabs.map((tab, index) => (
          <Link
            key={index}
            to={tab.path}
            className={clsx(styles['tab'], {
              [styles['active']]: location.pathname === tab.path,
            })}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </div>
  )
}
